"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Button = _interopRequireDefault(require("@react/react-spectrum/Button/js/Button"));

var _PinOff = _interopRequireDefault(require("@react/react-spectrum/Icon/PinOff"));

var _TooltipButton = _interopRequireDefault(require("../TooltipButton"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2020 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ***************************************************************************/
var ItemFooterActions = /*#__PURE__*/_react.default.memo(function (_ref) {
  var handlePinClick = _ref.handlePinClick,
      isAnnotating = _ref.isAnnotating,
      isPinnable = _ref.isPinnable,
      isVisible = _ref.isVisible,
      intl = _ref.intl,
      touchControls = _ref.touchControls;
  var pinProps = {
    'data-annotation-button': true,
    'data-test': 'pin-button',
    className: 'tool-button',
    variant: 'tool',
    icon: /*#__PURE__*/_react.default.createElement(_PinOff.default, null),
    onMouseDown: handlePinClick,
    selected: isAnnotating
  };
  var PinButton = _Button.default;

  if (!touchControls) {
    PinButton = _TooltipButton.default;
    pinProps.tooltip = intl.formatMessage({
      id: 'comments.textarea_input.pin.tooltip'
    });
  }

  return /*#__PURE__*/_react.default.createElement("div", {
    className: "footer-actions ".concat(touchControls ? 'touch-controls' : '')
  }, isVisible && isPinnable && /*#__PURE__*/_react.default.createElement(PinButton, pinProps));
});

ItemFooterActions.displayName = 'ItemFooterActions';
ItemFooterActions.defaultProps = {
  isPinnable: false,
  isAnnotating: false,
  isVisible: true,
  touchControls: false
};
ItemFooterActions.propTypes = {
  handlePinClick: _propTypes.default.func.isRequired,
  isAnnotating: _propTypes.default.bool,
  intl: _propTypes.default.shape({
    formatMessage: _propTypes.default.func.isRequired
  }).isRequired,
  isPinnable: _propTypes.default.bool,
  isVisible: _propTypes.default.bool,
  touchControls: _propTypes.default.bool
};
var _default = ItemFooterActions;
exports.default = _default;